import { render } from "./right-menu-button.vue?vue&type=template&id=54b0a0ca"
import script from "./right-menu-button.vue?vue&type=script&lang=js"
export * from "./right-menu-button.vue?vue&type=script&lang=js"
script.render = render

export default script